const Smiley = ({ className, color }) => (
  <svg
    width="50"
    height="51"
    className={className}
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25 0.0273438C38.7851 0.0273438 50 11.2423 50 25.0273C50 38.8124 38.7851 50.0273 25 50.0273C11.2149 50.0273 0 38.8124 0 25.0273C1.41389e-05 11.2423 11.2149 0.0273579 25 0.0273438ZM25 2.50781C12.5823 2.50787 2.47955 12.6106 2.47949 25.0283C2.47949 37.4461 12.5819 47.5488 25 47.5488C37.4178 47.5488 47.5205 37.4461 47.5205 25.0283C47.5205 12.6106 37.4177 2.50781 25 2.50781Z"
      fill={color}
    />
    <path
      d="M38.792 19.553C38.792 21.7352 37.0228 23.5045 34.8401 23.5045C32.6579 23.5045 30.8887 21.7352 30.8887 19.553C30.8887 17.3708 32.6579 15.6016 34.8401 15.6016C37.0228 15.6016 38.792 17.3708 38.792 19.553Z"
      fill={color}
    />
    <path
      d="M19.1114 19.553C19.1114 21.7352 17.3421 23.5045 15.1599 23.5045C12.9772 23.5045 11.208 21.7352 11.208 19.553C11.208 17.3708 12.9772 15.6016 15.1599 15.6016C17.3421 15.6016 19.1114 17.3708 19.1114 19.553Z"
      fill={color}
    />
    <path
      d="M32.3609 32.0313C31.0776 32.0313 30.3685 32.4844 29.8509 32.816C29.454 33.0694 29.2361 33.2095 28.6783 33.2095C28.1205 33.2095 27.9017 33.0694 27.5048 32.816C26.9872 32.4848 26.2781 32.0313 24.9948 32.0313C23.7124 32.0313 23.0038 32.4844 22.4871 32.816C22.0901 33.0694 21.8727 33.2095 21.3149 33.2095C20.7588 33.2095 20.5405 33.0698 20.1453 32.8164C19.6282 32.4852 18.92 32.0317 17.638 32.0317C16.9536 32.0317 16.3984 32.5873 16.3984 33.2713C16.3984 33.9557 16.954 34.5109 17.638 34.5109C18.1941 34.5109 18.4124 34.6505 18.8076 34.9039C19.3247 35.2351 20.0329 35.6887 21.3149 35.6887C22.5982 35.6887 23.3064 35.2351 23.8235 34.9039C24.2204 34.6505 24.4379 34.5109 24.9953 34.5109C25.553 34.5109 25.7718 34.651 26.1688 34.9043C26.6863 35.2356 27.3954 35.6891 28.6787 35.6891C29.9612 35.6891 30.6702 35.236 31.1878 34.9043C31.5847 34.651 31.8027 34.5109 32.3613 34.5109C33.0458 34.5109 33.6009 33.9553 33.6009 33.2713C33.6005 32.5873 33.0453 32.0312 32.3609 32.0312V32.0313Z"
      fill={color}
    />
  </svg>
);

export default Smiley;
